import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "tabs" }
const _hoisted_2 = { class: "tab-headers" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "tab-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
          return (_openBlock(), _createElementBlock("li", {
            key: tab.index,
            class: _normalizeClass({ active: _ctx.activeIndex === tab.index, disabled: tab.disabled }),
            onClick: ($event: any) => (_ctx.setActive(tab.index))
          }, [
            _createElementVNode("a", null, _toDisplayString(_ctx.t(tab.title)), 1)
          ], 10, _hoisted_3))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}